import { LocalStorageService } from './../../../core/services/local-storage.service';
import { environment } from './../../../../environment/environment';
import { SortDataService } from './../../../core/services/sortdata';
import { CallOfferService } from './../../../core/services/call-offer-service/call-offer.service';
import { DatePipe } from '@angular/common';
import { Component, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CreateCallOffer, translations } from './../../../core/models/call-offer';
import {
  callofferajout,
  calloffererreur,
  calloffermodifie,
  confirmBaremeMsg,
} from './../../../core/models/messages';
import { patternName } from './../../../core/models/pattern';
import { Country, State } from 'country-state-city';
import * as moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
const DOMPurify = require('dompurify')
@Component({
  selector: 'app-addappeloffre',
  templateUrl: './addappeloffre.component.html',
  styleUrls: ['./addappeloffre.component.css'],
})
export class AddappeloffreComponent {
  idCompany!: number;
  isCollapsed = true;
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  sortAttr = '';
  name = 'Angular';
  skillsCompany: any;
  skills: any[] = [];
  calljobinfo_info!: CreateCallOffer;
  countries: any = [];
  states: any = [];
  createform: FormGroup = this.registerForm();
  loadSpinnerTable: boolean = false;
  loadSpinner: boolean = false;
  listCallOffers: any;
  closeResult = '';
  p: number = 1;
  job_request_id: any;
  isexiste = false;
  displayedItems: any[] = [];
  detailcall: any;
  mobilities: any[] = [];
  /* any */
  file: any;
  url: string = environment.baseUrl + '/api';
  urlimage: string = environment.baseUrlGalery;

  /* form data */
  formData = new FormData();

  /* subscriprion */
  private unsubscribeAll: Subject<void> = new Subject();
  fileError: string = '';
  fileExtention: string = '';

  selectedCallOffer: any;
  /* number */
  totalItems!: number;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  currentSortDirection: number = 2;
  dataCallOffer: any;

  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];

  postType = [
    { id: '1', name: 'A distance' },
    { id: '2', name: 'Hybride' },
    { id: '3', name: 'Sur site' },
  ];
  contratType = [
    { id: '1', name: 'Alternance' },
    { id: '2', name: 'Autres type de contrat' },
    { id: '3', name: 'CDD' },
    { id: '4', name: 'CDI' },
    { id: '5', name: 'Freelance' },
    { id: '6', name: 'Portage salarial' },
    { id: '7', name: 'Stage' },
  ];
  submitted: boolean = false;
  idCallOffer!: number;
  updatedCallOfferData: any;
  postTypeOptions: { [key: string]: string } = {
    '1': 'A distance',
    '2': 'Hybride',
    '3': 'Sur site',
  };
  availabilituyTypeOptions: { [key: string]: string } = {
    '1': 'Immédiate',
    '2': '1 mois',
    '3': '2 mois',
    '4': '3 mois',
    '5': '4 mois',
    '6': '5 mois',
  };

  contratTypeOptions: { [key: string]: string } = {
    '1': 'Alternance',
    '2': 'Autres type de contrat',
    '3': 'CDD',
    '4': 'CDI',
    '5': 'Freelance',
    '6': 'Portage salarial',
    '7': 'Stage',
  };

  dedieau: { [key: string]: string } = {
    '1': 'Dedie au particulier',
    '2': 'Dédié aux ESN',
  };
  showDedicatedToESNCheckbox: boolean = true;

  isDedicatedToParticulier = 1;
  isDedicatedToESN = 2;
  skillsList: { name_FR: string }[] = [];
  /* object */
  contractTypesList: { id: string; name: string }[] = [
    { id: '1', name: 'Alternance' },
    { id: '2', name: 'Autres type de contrat' },
    { id: '3', name: 'CDD' },
    { id: '4', name: 'CDI' },
    { id: '5', name: 'Freelance' },
    { id: '6', name: 'Portage salarial' },
    { id: '7', name: 'Stage' },
    // Ajoutez d'autres types de contrat au besoin
  ];
  Statut: { id: string; name: string }[] = [
    { id: '0', name: 'actif' },
    { id: '1', name: 'inactif' },
  ];
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];

  /* formGroup */
  id: any;
  backGroundColors: string[] = ['blue', 'orange'];
  searchForm: FormGroup = this.createSearchForm();
  idclientConnected: any;
  pagination : boolean =false;
  /* modal */
  modalRef?: BsModalRef;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  stateList: any = [];

  constructor(
    private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer,
    private callofferservice: CallOfferService,
    private formBuilder: FormBuilder,
    private sortDataService: SortDataService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}

  toolbarOptions = [
    ['bold', 'italic', 'underline'],
    [{ header: 1 }, { header: 2 }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }], // outdent/indent
    ['clean'],
  ];

  ngOnInit() {
    this.id = this.localStorageService.getData('clientConnected');
    console.log('liste call', this.id);
    this.getListSkills();
    console.log('liste call', this.getListSkills());
    this.countries = Country.getAllCountries();
    this.getListAppel();
    
  }
  translateCountryName(name: string): string {
    
    return translations[name] || name;
  }
  /* change country select and delete the string Governorate from state name*/
  showPasseportTalent: boolean = false;
  onCountryChange(mode: string): void {
    this.createform.get('city')?.enable();
    this.countries = this.createform.get('country')?.value;
    this.countries = this.countries.map(
      (item: any) => this.paysList.filter((it) => it.name === item)[0]
    );

    console.log('item of countries ', this.countries);
    this.stateList.length = 0;
    // if (event.length) {
    this.countries.forEach((item: any) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    console.log('stateList ', this.stateList);
    this.mobilities = this.createform.get('city')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      console.log('size of mobilities ', this.mobilities.length);
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.createform.get('city')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.createform.get('city')?.setValue(null);
    }
    this.showPasseportTalent = this.countries.some(
      (country: any) => country.name === 'France'
    );
  }
  onMobilityChange(mode: string) {
    this.mobilities = this.createform.get('city')?.value;
    let paysLists: any[] = [];
    this.countries = this.createform.get('country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter: any[] = [];
    paysLists.forEach((item) => {
      State.getStatesOfCountry(item.isoCode).forEach(item=> {
        stateListAfter.push(item.name);    ////  }
      })
    });
    console.log('stateList in change mobilities mobilities : ', this.mobilities);
    console.log('stateList in change mobilities stateListAfter  : ', stateListAfter);
    this.stateList = [...new Set(this.mobilities.concat(stateListAfter))];
    console.log('stateList in change mobilities : ', this.stateList);
    this.mobilities = this.createform.get('city')?.value;
  
    if (this.countries.length != 0) {
      if (this.mobilities.length === 0 && this.stateList.length === 0) {
        this.onCountryChange('add');
      }
    }
  }


  onCountryChangeSearch(mode: string): void {
    
    this.createform.get('city')?.enable();
    this.countries = this.createform.get('country')?.value;
    this.countries = this.countries.map(
      (item:any) => this.paysList.filter((it) => it.name === item)[0]
    );
    this.stateList.length = 0;
    this.mobilities = this.createform.get('city')?.value;
  
    this.countries.forEach((item:any) => {
      var after:any[]=State.getStatesOfCountry(item?.isoCode)
      if(after.length==0)
      after.push({name:"Tout le pays"})
      this.stateList.push(after);
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    if (this.mobilities != null && this.mobilities.length > 0) {
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      var differentItemsArray2:any[]=[];
      differentItemsArray2= this.mobilities.filter((item) => !differentItemsArray1.includes(item));
      this.createform.get('city')?.setValue(differentItemsArray2);
    }
   
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      if(this.countries.length==0) {
        this.createform.get('city')?.disable();
        this.createform.get('city')?.setValue(null);
        }
    
    }
  }
  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }
  formatDate(dateString: string | null): string {
    if (!dateString) {
      return '';
    }

    const date = new Date(dateString);
    return this.datePipe.transform(date, 'dd/mm/yyyy') || '';
  }

  createSearchForm(data?: any) {
    return this.formBuilder.group({
      ID_jobRequest: ['', data && data.ID_jobRequest],
      name: ['', data && data.name],
      years_of_experience: ['', data && data.years_of_experience],
      experience_range: ['', data && data.experience_range],
      contract_type: [[], data && data?.contract_type],
      desired_salary: ['', data && data.desired_salary],
      desired_salary_range: ['', data && data.desired_salary_range],
      tjm: ['', data && data.tjm],
      tjm_range: ['', data && data.tjm_range],
      post_type: [[], data && data.post_type],
      skillsOr: [[], data && data.skillsOr],
      skillsAnd: [[], data && data.skillsAnd],
      availability: [[], data && data.availability],
      country: [null, data && data.country],
      city: [[], data && data.city],
      start_date: ['', data && data.start_date],
      end_date: ['', data && data.end_date],
      profil_étrangers: [null, data && data.profil_étrangers],
      passeport_talent: [null, data && data.passeport_talent],
      statut: ['', data && data.statut],
      client_id: this.localStorageService.getData('clientConnected'),
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }

  /* filter job offer */
  searchOfferr() {
    this.spinner.show();
    let data = {
      ID_jobRequest: this.searchForm.value.ID_jobRequest,
      name: this.searchForm.value.name,
      years_of_experience: this.searchForm.value.years_of_experience,
      experience_range: this.searchForm.value.experience_range,
      contract_type: this.searchForm.value.contract_type,
      desired_salary: this.searchForm.value.desired_salary
        ? this.searchForm.value.desired_salary.toString()
        : '',
      desired_salary_range: this.searchForm.value.desired_salary_range
        ? this.searchForm.value.desired_salary_range.toString()
        : '',
      tjm: this.searchForm.value.tjm
        ? this.searchForm.value.tjm.toString()
        : '',
      tjm_range: this.searchForm.value.tjm_range
        ? this.searchForm.value.tjm_range.toString()
        : '',
      post_type: this.searchForm.value.post_type,
      skillsOr: this.searchForm.value.skillsOr,
      skillsAnd: this.searchForm.value.skillsAnd,
      availability: this.searchForm.value.availability,

      start_date:
        this.searchForm.value.start_date != ''
          ? moment(this.searchForm.value.start_date).format('YYYY-MM-DD')
          : '',
      end_date:
        this.searchForm.value.end_date != ''
          ? moment(this.searchForm.value.end_date).format('YYYY-MM-DD')
          : '',

      client_final_name: this.searchForm.value.client_final_name,
      sort: this.currentSortDirection,
      sortAttribute: 'name',
      page: this.currentPage,
      per_page: this.itemsPerPage,
      search: this.transformSearch(this.searchForm.value?.search),
    };
    this.callofferservice
      .searchRequestOffer(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res: any) => {
          if ( this.currentPage > 1) {
            this.currentPage = 1;
            this.searchOfferr();
          } else {
            this.spinner.hide();
            this.listCallOffers = res.data.data.slice(0, this.endIndex);
            this.totalItems = res.data.total;
          }
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }
  reset() {
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.getListAppel();
  }
  initForm(data?: any): void {
    this.createform = this.registerForm(data);
  }

  selectCallOffer(callOffer: any) {
    this.selectedCallOffer = { ...callOffer };
  }
  registerForm(data?: any) {
    const defaultCallOffer: CreateCallOffer = {
      name: data ? data.name : '',
      post_type: data ? data.post_type : '',
      city: data ? data.city : '',
      country: data ? data.country : '',
      availability: data ? data.availability : '',
      salary: data ? data.salary : '',
      years_of_experience: data ? data.years_of_experience : '',
      contract_type: data ? data.contract_type : '',
      tjm: data ? data.tjm : '',
      description: data ? data.description : '',
      skills: data ? data.skills : [],
      dedicated_to: data ? data.dedicated_to : true,
      profile_abroad: data ? data.profile_abroad : '',
      passeport_talent: data ? data.passeport_talent : '',
      otherSkills: [[]],
    };

    return this.formBuilder.group({
      name: [
        data ? data.name : '',
        [Validators.required, Validators.pattern(patternName)],
      ],
      post_type: [data ? data.post_type : null],
      city: [data ? data.city : []],
      country: [data ? data.country : [], Validators.required],
      availability: [data ? data.availability : null],
      salary: [data ? data.salary : ''],
      years_of_experience: [
        data ? data.years_of_experience : '',
        [Validators.required],
      ],
      contract_type: [data ? data.contract_type : []],
      tjm: [data ? data.tjm : ''],
      description: [data ? data.description : '', [Validators.required]],
      skills: [data ? data.skills : []],
      otherSkills: [[]],
      dedicated_to: [data ? data.dedicated_to : true],
      profile_abroad: [data ? data.profile_abroad : ''],
      passeport_talent: [data ? data.passeport_talent : ''],
      role_id: 4,
    });
  }

  sanitizeDescription(html: string): string {
    const sanitizedDescription: SafeHtml =
      this.sanitizer.bypassSecurityTrustHtml(html);
    const plainTextDescription = this.stripHtmlTags(
      sanitizedDescription.toString()
    );
    return plainTextDescription;
  }

  stripHtmlTags(html: string): string {
    return html ? html.replace(/<[^>]*>/g, '') : '';
  }
  getListSkills() {
    this.callofferservice.getSkillsCompany().subscribe({
      next: (res) => {
        this.skillsList = res.data;
        console.log('  this.skillsList', this.skillsList);
      },
      error: (err) => {
        console.log('error', err);
      },
    });
  }
  ajoutProfilecalloffer() {
    console.log("form",this.createform.value)
    if (this.createform.invalid) {
      this.createform.markAllAsTouched();
      this.createform.markAsDirty();
      return;
    }
    let id = this.localStorageService.getData('clientConnected');
    console.log('value of form groupe ', this.createform.value);
    const formData = new FormData();
    formData.append('name', this.createform.value.name);
    formData.append('post_type', this.createform.value.post_type);
    // formData.append('country', this.createform.value.country);

    const cityTypes = this.createform.value.city;
    console.log('cityTypes:', cityTypes);
    if (Array.isArray(cityTypes)) {
      for (const cityType of cityTypes) {
        formData.append('city[]', cityType);
      }
    }
    const countryTypes = this.createform.value.country;
    console.log('cityTypes:', countryTypes);
    if (Array.isArray(countryTypes)) {
      for (const countryType of countryTypes) {
        formData.append('country[]', countryType);
      }
    }
    formData.append('availability', this.createform.value.availability);
    formData.append(
      'salary',
      this.createform.value.salary ? String(this.createform.value.salary) : '0'
    );
    formData.append(
      'years_of_experience',
      this.createform.value.years_of_experience
    );
    // formData.append("contract_type", this.createform.value.contract_type);
    const contractTypes = this.createform.value.contract_type;
    console.log('contractTypes:', contractTypes);
    if (Array.isArray(contractTypes)) {
      for (const contractType of contractTypes) {
        formData.append('contract_type[]', contractType);
      }
    }
    console.log('contractTypes:', contractTypes);

    formData.append(
      'tjm',
      this.createform.value.tjm ? String(this.createform.value.tjm) : '0'
    );

    formData.append('description', this.createform.value.description);
    let otherSkills = this.createform.get('otherSkills')?.value;
    console.log('otherSkills', otherSkills);
    if (otherSkills && otherSkills.length > 0) {
    const allSkills = [otherSkills];
    this.createform.patchValue({ otherSkills: allSkills });
    console.log("otherskills1",allSkills)
    console.log("otherskills", this.createform.value.otherSkills)
    formData.append('otherSkills[]', this.createform.value.otherSkills);
    }
   

    formData.append('client_id', id ? id : '');
    formData.append(
      'profile_abroad',
      this.createform.value.profile_abroad ? '1' : '0'
    );
    formData.append(
      'passeport_talent',
      this.createform.value.passeport_talent ? '1' : '0'
    );

    if (this.createform.value.dedicated_to === true) {
      formData.append('dedicated_to', '1');
    }

    const skills = this.createform.get('skills')?.value;
    for (const skill of skills) {
      formData.append('skills[]', skill.id);
    }
    if (this.createform.value.description === null) {
      formData.delete('description');
    }
    if (this.createform.value.availability === null) {
      formData.delete('availability');
    }
    if (this.createform.value.post_type === null) {
      formData.delete('post_type');
    }

    this.callofferservice
      .createCallOffer(formData)
      .pipe()
      .subscribe({
        next: (res) => {
          this.calljobinfo_info = res.data;
          this.dataCallOffer = res.data;
          this.toastr.success(callofferajout);
          this.dataCallOffer = this.dataCallOffer.id;
          this.confirmBareme(this.dataCallOffer);
          this.spinner.hide();
          this.closeModal();
          this.getListAppel();
        },
        error: (err) => {
          console.log('error', err);
          this.toastr.error(calloffererreur);
        },
      });
  }

  confirmBareme(job_request_id: any) {
    Swal.fire({
      title: `${confirmBaremeMsg}`,
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Confirmer',
      confirmButtonColor: '#265D91',
      cancelButtonText: 'Ignorer',
      iconColor: '#28a745',
    }).then((result) => {
      if (result.isConfirmed) {
        this.navigateToAddBareme(job_request_id);
      } else {
        this.navigateToList();
      }
    });
  }
  navigateToList() {
    this.router.navigate(['/liste-appels-offres']);
  }
  navigateToAddBareme(job_request_id: any) {
    this.router.navigate([
      '/call-offer-bareme',
      { job_request_id: job_request_id },
    ]);
  }
  // Fonction pour vérifier si une valeur est numérique
  isNumeric(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }
  /* get indexes for pagination */
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.createform.dirty) {
        this.searchOfferr();
      } else if( (this.startIndex !=0 ||this.endIndex !=5) || this.pagination == true) {
        this.pagination = true;
        this.getListAppel();
      }
    }
  }

  closeModal() {
    this.modalRef?.hide();
    this.createform.reset();
    this.formData = new FormData();
    this.file = null;
    this.fileError = '';
    this.fileExtention = '';
  }

  sortData(item: string) {
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.sortAttr = item;
    console.log('form', this.searchForm.value);
    if (this.searchForm.dirty)
      this.listCallOffers = this.sortDataService.sortArray(
        this.listCallOffers,
        item,
        this.currentSortDirection
      );
    else this.getListAppel();
  }

  getListAppel() {
    this.spinner.show();
    let dataPyload =
      this.sortAttr == ''
        ? { id: this.id, per_page: this.itemsPerPage, page: this.currentPage }
        : {
            ...{
              id: this.id,
              per_page: this.itemsPerPage,
              page: this.currentPage,
            },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    console.log('data', dataPyload);
    this.callofferservice
      .getListOfferRequest(this.id, dataPyload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.listCallOffers = res.data.data
          // .slice(0, this.endIndex);
          console.log('calloffer', this.listCallOffers);
          this.totalItems = res.data.total;
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  deletecalloffer(id: any) {
    Swal.fire({
      title: 'Êtes-vous sûr(e) ?',
      text: 'Vous ne pourrez pas revenir en arrière !',
      icon: 'warning',
      showCancelButton: true,
      iconColor: '#ff0000',
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, supprimer !',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.callofferservice.deleteCallOffer(id).subscribe((res: any) => {
          console.log('responce', res);
          Swal.fire('Supprimé !', "L'appel d'offre a été supprimé.", 'success');
          this.getListAppel();
        });
      }
    });
  }

  openModal(template: TemplateRef<any>, data?: any, mode?: string) {
    this.idCallOffer = data.id;
    console.log('data', data);
    this.createform = this.registerForm(data);
    this.createform.get('contract_type')?.setValue(data.contract_type);
    this.createform.get('country')?.setValue(data.country);
    console.log('country', data.country);
    this.createform.get('city')?.setValue(data.city);
    console.log('cityyyyyyyyyyyyyyyy', this.createform.value.city);
    console.log('skills_job', data.skills_job);
    this.skills = [];
    let skillsArray = data.skills_job;
    console.log('skillsArray', skillsArray);
    if (skillsArray.length != 0) {
      for (let i = 0; i < skillsArray.length; i++) {
        this.skills.push(skillsArray[i].subCateg_id);
      }
    }
    console.log('skills id', this.skills);
    this.createform.get('skills')?.setValue(this.skills);
    console.log('skillIds', this.createform);
    console.log('updatte---', this.createform.value);
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  }

  updateCALLOFFER() {
    this.skills = [];
    const skills = this.createform.get('skills')?.value;

    console.log('skills', skills);
    for (const skill of skills) {
      this.skills.push(skill);
      console.log('skills after push', this.skills);
    }
    console.log('skillIds', this.createform);

    this.createform.patchValue({
      salary: this.createform.value.salary
        ? String(this.createform.value.salary)
        : '0',
      tjm: this.createform.value.tjm ? String(this.createform.value.tjm) : '0',
      years_of_experience: String(this.createform.value.years_of_experience),
    });
    for (let key in this.createform.value) {
      if (
        this.createform.value[key] === null ||
        this.createform.value[key].length === 0
      ) {
        delete this.createform.value[key];
      }
    }

    this.callofferservice
      .updateCallOffer(this.idCallOffer, this.createform.value)
      .subscribe((res: any) => {
        this.toastr.success(calloffermodifie);
        this.spinner.hide();
        this.closeModal();
        this.createform.reset();

        this.getListAppel();
      });
  }

  openModal1(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////

  /* key inter number */
  keyPress(event: any) {
    let pattern = /^[\d]$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && pattern && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    return pattern;
  }

  /* ************************* navigation company ********************* */
  profilCallNavigation(id: any) {
    this.router.navigate(['detail-offre', { id: id }]);
  }

  changeSkills(data: any) {
    console.log('aaaaaaaaaaaaaaaa', data);
    for (const iterator of data) {
      // TableDateCell.push(iterator.id)
    }
    console.log('eeeeeeeeeeee', this.createform);
  }
  updateSkills(event: any): void {
    this.createform.get('skills')?.setValue(event);
  }
    /* unsubscribe from api */
    ngOnDestroy() {
      this.unsubscribeAll.next();
      this.unsubscribeAll.complete();
    }

    onContentChange(event: any): void {
      if (event.html) {
        const sanitizedContent = DOMPurify.sanitize(event.html);
        if (sanitizedContent !== this.createform.get('description')?.value) {
          this.createform.patchValue(
            { description: sanitizedContent },
            { emitEvent: false } 
          );
        }
      }
    
    }
}
